import React from "react"
import PropTypes from "prop-types"

import { StarsBig } from "./Stars"

const ProductOrderRow = ({ fila, farm, form }) => {
  const { state, events } = form

  const precios = state.pickLocal ? state.preciosLocal : state.precios
  const etiquetaPrecios = state.pickLocal
    ? `Recoger en granja ${farm?.name || ""} desde`
    : "Entrega en región"

  const unaSolaZona = (fila.prices || []).length === 1

  return (
    <div className="ped-product">
      <div className="ped-product-band">{fila.product}</div>

      <div className="ped-product-body">
        <div className="ped-product-info">
          <div className="ped-product-datos">
            <div>
              <span className="ped-strong">Disponible:</span>{" "}
              <span className="ped-num">{fila.available_product}</span> Pzas
            </div>
            <div>
              <span className="ped-strong">Peso Promedio:</span>{" "}
              <span className="ped-num">
                {fila.weight} – {fila.weight_max}
              </span>{" "}
              Kg.
            </div>
            {farm?.local_delivery && fila.unit_price > 0 && (
              <div>
                <span className="ped-strong">Precio en sucursal:</span>{" "}
                <span className="ped-num">${fila.unit_price}</span>
              </div>
            )}
            <div>
              <span className="ped-strong">Observaciones:</span>{" "}
              {fila.observations}
            </div>
          </div>

          <div className="ped-product-calidad">
            <StarsBig label="Pigmento" value={fila.quality} />
            <StarsBig label="Calidad" value={fila.quality_2} />
            <StarsBig label="Salud del ave" value={fila.quality_3} />
          </div>
        </div>

        <div className="ped-product-form">
          <div>
            <label className="ped-label" htmlFor={`ped-ordenar-${fila.id}`}>
              Ordenar (Pzas)
            </label>
            <input
              id={`ped-ordenar-${fila.id}`}
              className="ped-field ped-field-cantidad ped-num"
              type="number"
              min="0"
              value={state.cantidades[fila.id] ?? ""}
              onChange={event => events.setCantidad(fila.id, event.target.value)}
              onWheel={event => event.target.blur()}
            />
          </div>

          <fieldset className="ped-zonas">
            <legend className="ped-label">
              {etiquetaPrecios}{" "}
              <span className="ped-label-nota">(Precio MXN)</span>
            </legend>
            {(fila.prices || []).map(precio => {
              const seleccionado = state.priceSelected[fila.id] === precio.id
              const nombreZona = `${precio.region} ${
                precio.subregion ? precio.subregion : ""
              }`.trim()

              return (
                <div className="ped-zona" key={precio.id}>
                  {unaSolaZona ? (
                    <span className="ped-dot is-on" />
                  ) : (
                    <input
                      className="ped-dot"
                      type="radio"
                      name={`ped-precio-${fila.id}`}
                      id={`ped-precio-${fila.id}-${precio.id}`}
                      checked={seleccionado}
                      onChange={() =>
                        events.setPrecioSeleccionado(fila.id, precio.id)
                      }
                    />
                  )}
                  <label
                    className="ped-zona-nombre"
                    htmlFor={
                      unaSolaZona
                        ? undefined
                        : `ped-precio-${fila.id}-${precio.id}`
                    }
                  >
                    {nombreZona}
                  </label>
                  <div className="ped-precio-group">
                    <span className="ped-precio-afijo">$</span>
                    <input
                      className="ped-precio-input ped-num"
                      type="number"
                      min="0"
                      step={0.01}
                      value={
                        Math.round((precios[fila.id]?.[precio.id] || 0) * 100) /
                        100
                      }
                      onChange={event =>
                        events.setPrecio(fila.id, precio.id, event.target.value)
                      }
                      onWheel={event => event.target.blur()}
                    />
                    <span className="ped-precio-afijo is-sufijo">MXN</span>
                  </div>
                </div>
              )
            })}
          </fieldset>

          <div>
            <label className="ped-label" htmlFor={`ped-obs-${fila.id}`}>
              Observaciones
            </label>
            <textarea
              id={`ped-obs-${fila.id}`}
              className="ped-field"
              rows={2}
              value={state.observaciones[fila.id] ?? ""}
              onChange={event =>
                events.setObservacion(fila.id, event.target.value)
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProductOrderRow.propTypes = {
  fila: PropTypes.object.isRequired,
  farm: PropTypes.object,
  form: PropTypes.object.isRequired,
}

export default ProductOrderRow
